module.exports = __webpack_public_path__ + "static/45af5eee-5b2e-4920-88dc-db50df86c912-495e6635451a1400bbb247d5c05557bd.woff2";